// extracted by mini-css-extract-plugin
export var closeButton = "_fr-1";
export var closeX = "_fr-3";
export var container = "_fr-0";
export var image = "_fr-2";